import { useAppStore } from "~/stores/appStore"
import { useUserStore } from "~/stores/userStore"

function redirectToOldVersion() {
  const config = useRuntimeConfig()
  const path = window.location.pathname.slice(4)
  const completeOldUrl = config.public.oldFrontendRoot + path
  window.location.href = completeOldUrl
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$router.beforeEach(() => {
    const current = useUserStore().current
    if (!current?.new_version_available) {
      useAppStore().movingVersions = true
      redirectToOldVersion()
    }
  })
})
